import useKeyboardShortcuts from "@/features/AtajosTeclado/useKeyboardShortcuts"

export default function KeyboardShortcutsHost() {
  useKeyboardShortcuts()
  return null
}
